import React, { useContext, useState } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useToast } from '../components/Toaster';
import { Button } from '../components/common';

// const EdjamonLogo = () => (
//     <div className="flex justify-center items-center">
//         <h1 className="text-4xl font-black text-red-500 relative">
//              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute -top-6 left-0 text-red-500" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z"></path>
//             </svg>
//             E<span className="text-secondary">d</span>JAMON
//         </h1>
//     </div>
// );
const EdjamonLogo = () => (
    <div className="flex justify-center items-center">
        <img 
            src="/logo/EdJAMON.png" 
            alt="EdJAMON Logo" 
            className="h-12 w-auto object-contain"
        />
    </div>
);


const EyeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>;
const EyeOffIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" /></svg>;

const LoginPage: React.FC = () => {
    const auth = useContext(AuthContext);
    const navigate = useNavigate();
    const toast = useToast();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        if (auth) {
            setIsLoading(true);
            try {
                const user = await auth.login(email, password);
                toast.success("Login successful!");
                // Navigate based on userMode from API response
                if (user.mode === "online") {
                    navigate("/dashboard");
                } else if (user.mode === "offline") {
                    navigate("/dashboard");
                } else {
                    navigate("/dashboard"); // Default fallback
                }
            } catch (err: any) {
                console.error("Login Error:", err);
                // Prioritize API error message, then generic error message, then a fallback.
                toast.error(err?.response?.data?.message || err.message || "Login failed. Please try again.");
            } finally {
                setIsLoading(false);
            }
        }
    };
    
    // // Set initial credentials for demo
    // React.useEffect(() => {
    //     setEmail('online@edjamon.com');
    //     setPassword('password');
    // }, []);

    return (
         <div className="min-h-screen bg-light flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="w-full max-w-sm p-8 space-y-8 bg-white rounded-xl shadow-lg">
                <div>
                    <EdjamonLogo />
                    <h2 className="mt-6 text-center text-xl font-bold text-gray-800">Student Portal</h2>
                    <p className="mt-1 text-sm text-center text-gray-500">Sign in to continue your learning</p>
                </div>
                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="text-sm font-medium text-gray-700 sr-only">Email address</label>
                        <input id="email" name="email" type="email" placeholder="Email address" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary" />
                    </div>
                    <div className="relative">
                        <label htmlFor="password"className="text-sm font-medium text-gray-700 sr-only">Password</label>
                        <input id="password" name="password" type={passwordVisible ? 'text' : 'password'} placeholder="Password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary" />
                        <button type="button" onClick={() => setPasswordVisible(!passwordVisible)} className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600">
                           {passwordVisible ? <EyeOffIcon /> : <EyeIcon />}
                        </button>
                    </div>

                    <div className="flex items-center justify-between text-sm">
                        <div className="flex items-center">
                            <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" />
                            <label htmlFor="remember-me" className="ml-2 block text-gray-700">Remember me</label>
                        </div>
                        <a href="#" className="font-medium text-primary hover:text-primary-600">Forgot password?</a>
                    </div>

                    <Button type="submit" size="lg" className="w-full" disabled={isLoading}>
                        {isLoading ? 'Signing in...' : 'Sign in'}
                    </Button>
                </form>
                 <div className="text-xs text-gray-400 text-center">
                    <p>Demo credentials have been pre-filled.</p>
                    <p>(Try <span className="font-semibold">online@edjamon.com</span> or <span className="font-semibold">offline@edjamon.com</span>)</p>
                </div>
            </div>
        </div>
    );
};

const AuthPage: React.FC = () => (
    <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/auth/login" />} />
    </Routes>
);

export default AuthPage;